/* globals fetch localStorage */

// eslint-disable-next-line import/no-cycle
import { encodeParams } from './helper';

const stagingUSMultitenantDomain = '.staging-admin.zippityinfra.com';
const stagingSimpleMultitenantDomain =
  'https://simple360-xingkuiwang-simpletire.vercel.app/dashboard/ShopLocal-Mobile/1C7nn2dTMqQxYxGAoHvd1x/Zippity/';

const prodUSMultitenantDomain = '.admin.zippityinfra.com';
const prodSimpleMultitenantDomain =
  'https://app.simple360.com/dashboard/ShopLocal-Mobile/1C7nn2dTMqQxYxGAoHvd1x/Zippity/';

const stagingiFrameDomain = '.staging-admin.iframe.zippityinfra.com';
const prodiFrameDomain = '.admin.iframe.zippityinfra.com';

const allMultitenantDomains = [
  stagingUSMultitenantDomain,
  prodUSMultitenantDomain,
  stagingiFrameDomain,
  prodiFrameDomain,
];

const getSubdomainPrefix = () => {
  const { hostname } = window.location;

  let retVal = null;
  allMultitenantDomains.forEach((domain) => {
    if (hostname.endsWith(domain)) {
      const len = hostname.length - domain.length;
      const prefix = hostname.substring(0, len);
      console.log('HOSTNAME', hostname);
      console.log('PREFIX', prefix);
      retVal = prefix;
    }
  });
  return retVal;
};

// for browser
export const redirectUrl = () => {
  const hostname = window.location.href;
  if (hostname.includes(stagingUSMultitenantDomain)) {
    window.location.href = stagingSimpleMultitenantDomain;
  }
  if (hostname.includes(prodUSMultitenantDomain)) {
    window.location.href = prodSimpleMultitenantDomain;
  }
};

export const getBrain2Url = () => {
  const subdomainPrefix = getSubdomainPrefix();
  if (subdomainPrefix) {
    const { hostname } = window.location;
    if (
      hostname.endsWith(stagingUSMultitenantDomain) ||
      hostname.endsWith(stagingiFrameDomain)
    ) {
      return 'https://stbrain2-staging.zippityinfra.com';
    }
    if (
      hostname.endsWith(prodUSMultitenantDomain) ||
      hostname.endsWith(prodiFrameDomain)
    ) {
      return 'https://stbrain2-prod.zippityinfra.com';
    }
  }
  return process.env.REACT_APP_BRAIN2_HOSTNAME;
};

export const getProNameHeader = () => {
  return getSubdomainPrefix() || process.env.REACT_APP_Z3P;
};

function getBrain2Headers() {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Pro-Name': getProNameHeader(),
  };

  const token = localStorage.getItem('token');
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
}

function convertPromise(promise, asJson) {
  if (asJson) {
    return promise.then((r) => r.json());
  }
  return promise;
}

export const ResponseStatus = {
  OK: 'OK',
  ERROR: 'ERROR',
};

export const apiGetAsync = async (path, params = null, asJson = true) => {
  let fullPath = `${getBrain2Url()}${path}`;
  if (params) {
    const queryString = encodeParams(params);
    fullPath = `${fullPath}?${queryString}`;
  }
  const headers = getBrain2Headers();
  try {
    const resp = await fetch(fullPath, { headers });
    return asJson ? resp.json() : resp;
  } catch (ex) {
    console.error(ex);
  }
  // used "Status" instead of "status" here for now, because that is what we typically return from brain2
  return {
    Status: ResponseStatus.Error,
    Message: 'Something went wrong.',
  };
};

export const apiPutAsync = async (path, payload = null, asJson = true) => {
  const fullPath = `${getBrain2Url()}${path}`;
  const body = payload ? JSON.stringify(payload) : null;
  const headers = getBrain2Headers();

  const resp = await fetch(fullPath, { method: 'PUT', headers, body });
  return asJson ? resp.json() : resp;
};

export const apiPostAsync = async (path, payload = null, asJson = true) => {
  const fullPath = `${getBrain2Url()}${path}`;
  const body = payload ? JSON.stringify(payload) : null;
  const headers = getBrain2Headers();

  const resp = await fetch(fullPath, { method: 'POST', headers, body });
  return asJson ? resp.json() : resp;
};

export const apiGet = (path, params = null, asJson = true) => {
  let fullPath = `${getBrain2Url()}${path}`;
  if (params) {
    const queryString = encodeParams(params);
    fullPath = `${fullPath}?${queryString}`;
  }
  const headers = getBrain2Headers();

  const promise = fetch(fullPath, { headers });
  return convertPromise(promise, asJson);
};

export const apiPost = (path, payload = null, asJson = true) => {
  const fullPath = `${getBrain2Url()}${path}`;
  const body = payload ? JSON.stringify(payload) : null;
  const headers = getBrain2Headers();

  const promise = fetch(fullPath, { method: 'POST', headers, body });
  return convertPromise(promise, asJson);
};

export const apiPut = (path, payload = null, asJson = true) => {
  const fullPath = `${getBrain2Url()}${path}`;
  const body = payload ? JSON.stringify(payload) : null;
  const headers = getBrain2Headers();

  const promise = fetch(fullPath, { method: 'PUT', headers, body });
  return convertPromise(promise, asJson);
};

export const apiDelete = (path, asJson = true) => {
  const fullPath = `${getBrain2Url()}${path}`;
  const headers = getBrain2Headers();

  const promise = fetch(fullPath, { method: 'DELETE', headers });
  return convertPromise(promise, asJson);
};

export async function getZ3PConfiguration() {
  return apiGet(`/admin-z3p-configuration`);
}
